export const PAGE_CONTENT_ID = 'page-content-layer'
export const APPLICATION_LAYER_ID = 'application-layer'
export const DIALOGS_LAYER_ID = 'dialogs-layer'
export const TOP_LAYER_ID = 'top-layer'
export const CHATBOT_LAYER_ID = 'chatbot-layer'
